import { render, staticRenderFns } from "./CensorItem.vue?vue&type=template&id=f124f948&scoped=true&"
import script from "./CensorItem.vue?vue&type=script&lang=js&"
export * from "./CensorItem.vue?vue&type=script&lang=js&"
import style0 from "./CensorItem.vue?vue&type=style&index=0&id=f124f948&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f124f948",
  null
  
)

export default component.exports